import React, { useId } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'

import { LntButton, LntDrawer, LntForm, LntFormItem, LntInput } from '@app/components/base'

import { useNotification } from '@app/hooks'

import { MONITORING_VALIDATION_KEY } from '@app/constants/queryKeys'

import { isEmptyObject } from '@app/utils/object'

import {
  getMonitoringValidationPromoPriceTransitionConfig,
  patchMonitoringValidationPromoPriceTransitionConfig
} from '@app/api/routes/monitoringValidation'

import styles from './styles.module.scss'

import type { PromoPriceTransitionDrawerProps } from './types'
import type { PatchMonitoringValidationPromoPriceTransitionConfigData } from '@app/api/routes/monitoringValidation/types'

const title = 'Перенос цен в промо'

export const PromoPriceTransitionDrawer: React.FC<PromoPriceTransitionDrawerProps> = props => {
  const { onClose } = props

  const formId = useId()

  const queryClient = useQueryClient()
  const notification = useNotification()
  const form = useForm<PatchMonitoringValidationPromoPriceTransitionConfigData>()

  const { data: configData } = useQuery({
    queryKey: [MONITORING_VALIDATION_KEY.promoPriceTransitions],
    queryFn: async () => await getMonitoringValidationPromoPriceTransitionConfig()
  })

  const patchConfigDataMutation = useMutation({
    mutationFn: patchMonitoringValidationPromoPriceTransitionConfig,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [MONITORING_VALIDATION_KEY.promoPriceTransitions] })

      notification.success({
        message: 'Успешно изменен период обращения в историю цен.'
      })

      onClose()
    }
  })

  const handleSubmit = (): void => {
    const { promoPriceTransitionHistoricalDepth } = form.getValues()

    if (promoPriceTransitionHistoricalDepth) {
      patchConfigDataMutation.mutate({ promoPriceTransitionHistoricalDepth })
    }
  }

  const footerButtons: React.ReactNode = (
    <div className={ styles.promoPriceTransitionDrawer__footer }>
      <LntButton
        htmlType='submit'
        form={ formId }
        disabled={ isEmptyObject(form.formState.dirtyFields) }
      >
        Сохранить
      </LntButton>
    </div>
  )

  return (
    <LntDrawer
      { ...props }
      title={ title }
      width={ 424 }
      footer={ footerButtons }
    >
      <LntForm
        layout='vertical'
        className={ styles.priceTranslationDrawer__form }
        formInstance={ form }
        onSubmit={ handleSubmit }
        id={ formId }
      >
        <LntFormItem
          name='promoPriceTransitionHistoricalDepth'
          defaultValue={ configData?.promoPriceTransitionHistoricalDepth }
          label='Период обращения в историю цен'
        >
          <LntInput
            className={ styles.priceTranslationDrawerFormTop__inputDays }
            placeholder='Кол-во дней'
            type='number'
          />
        </LntFormItem>
      </LntForm>
    </LntDrawer>
  )
}
